import { useAppAuthContext } from "../core";

/**
 * Unified authentication hook that provides a consistent interface
 * regardless of whether Auth0 is enabled or disabled.
 *
 * Adapted from insights-home: Home also checks for an embedding host app
 * via useInsightHomeAdapters() and defers to its auth when present. The
 * portal is a standalone app (no host-embedding adapter layer), so this
 * just exposes the local Auth0 context directly. Revisit if the portal
 * ever needs to run embedded inside another app's shell.
 */
export function useAuth() {
  return useAppAuthContext();
}
